import {
  BaseItem,
  CanHaveBorderRadius,
  CanHaveCrop,
  CanHaveAnimation,
  CanHaveRotation,
  CanHaveZoomKeyframes,
} from '../shared';
import {
  EditorItemType,
  EditorStarterItem,
} from '@/features/remotion-editor/editor/items/item-type';
import type { PageKeyframe } from './page-keyframes';

/**
 * 문서 아이템 공통 — 문서(PdfAsset)의 한 페이지를 이미지처럼 렌더한다.
 * pdf/ppt 는 렌더·능력치가 동일하고 출처(원본 확장자)만 다르다 — pptx 는 업로드
 * 시 LibreOffice 변환을 거쳐 에셋 자체가 변환된 PDF 다 (설계:
 * docs/superpowers/specs/2026-07-17-remotion-pdf-ppt-items-design.md).
 */
type DocumentItemBase = BaseItem &
  CanHaveBorderRadius &
  CanHaveCrop &
  CanHaveAnimation &
  CanHaveRotation &
  CanHaveZoomKeyframes & {
    assetId: string;
    /** 0-based 시작 페이지 — pageKeyframes 의 첫 경계 이전 구간에 표시 */
    pageIndex: number;
    /** 페이지 타임라인 — "이 시점부터 이 페이지" (page-keyframes.ts). 없으면 고정 */
    pageKeyframes?: PageKeyframe[];
    /** 페이지 경계 플립 전환 길이(초). 미지정 시 기본값, 0 = 컷 */
    pageTransitionDurationInSeconds?: number;
    keepAspectRatio: boolean;
    fadeInDurationInSeconds: number;
    fadeOutDurationInSeconds: number;
  };

export type PdfItem = DocumentItemBase & {
  type: Extract<EditorItemType, 'pdf'>;
};

export type PptItem = DocumentItemBase & {
  type: Extract<EditorItemType, 'ppt'>;
};

export type DocumentItem = PdfItem | PptItem;

export const isDocumentItem = (
  item?: EditorStarterItem,
): item is DocumentItem => {
  if (!item) return false;
  return item.type === 'pdf' || item.type === 'ppt';
};
